const LOGO_URL =
  "https://sonarbanglahaat.com/wp-content/uploads/2025/12/cropped-Logo-Photoroom-1.png";

export default function BrandHeader() {
  return (
    <header
      className="absolute top-0 left-0 right-0 z-40 flex items-start justify-between px-5 md:px-10 lg:px-14 pt-5 md:pt-8 pointer-events-none"
      data-testid="brand-header"
    >
      <a
        href="https://sonarbanglahaat.com"
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto inline-flex items-center gap-3"
        data-testid="brand-logo-link"
      >
        <img
          src={LOGO_URL}
          alt="Sonar Bangla Haat"
          className="h-11 md:h-14 lg:h-16 w-auto select-none"
          draggable="false"
        />
      </a>
      <div className="hidden md:flex flex-col items-end pointer-events-auto">
        <span className="eyebrow">Vendor Onboarding</span>
        <span
          className="font-editorial italic text-[15px] text-[color:var(--sbh-ink-2)] mt-1"
          data-testid="brand-tagline"
        >
          A quiet marketplace for a loud heritage.
        </span>
      </div>
    </header>
  );
}
